// Sign-in (SFCR_AUTH_MODE=local). After signing in, the user returns to the page they asked for.
import { useState } from "react";
import { api } from "../api/client";
import { invalidate, useMutation } from "../api/resource";
import { ErrorState } from "../components/ui";
import { w } from "../i18n";

function safeNext(): string {
  const next = new URLSearchParams(window.location.search).get("next") || "/";
  return next.startsWith("/") && !next.startsWith("//") ? next : "/";  // never an external redirect
}

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const login = useMutation(api.login);
  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (await login.run(email.trim(), password)) {
      invalidate("auth:");
      window.location.assign(safeNext());
    }
  };
  return <main className="ws-contribute">
    <div className="ws-brand" style={{ marginBottom: 16 }}><img src="/seabird-tech-logo.svg" alt="SeaBird" height={22} /></div>
    <form className="ws-card ws-card-pad" onSubmit={submit}>
      <h1 style={{ margin: "0 0 4px", fontSize: 22 }}>{w("login.title")}</h1>
      <p className="ws-muted" style={{ marginTop: 0 }}>{w("login.lead")}</p>
      <div className="ws-field"><label htmlFor="login-email">{w("login.email")}</label>
        <input id="login-email" className="ws-input" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} required /></div>
      <div className="ws-field"><label htmlFor="login-password">{w("login.password")}</label>
        <input id="login-password" className="ws-input" type="password" autoComplete="current-password" value={password}
          onChange={e => setPassword(e.target.value)} required /></div>
      {login.error && <ErrorState title={w("login.error")} error={login.error} />}
      <button className="ws-btn primary" type="submit" disabled={login.pending || !email.trim() || !password}>{w("login.submit")}</button>
      <p className="ws-small ws-faint" style={{ marginBottom: 0 }}>{w("login.note")}</p>
    </form>
  </main>;
}
